import moment from 'moment';

export const getPeriodSelectorStartDate = state =>
  state.periodSelector.startDate && moment(state.periodSelector.startDate);

export const getPeriodSelectorEndDate = state =>
  state.periodSelector.endDate && moment(state.periodSelector.endDate);

export const getPeriodSelectorDateField = state => state.periodSelector.dateField;

export const getPeriodSelectorDatePicker = state => state.periodSelector.datePicker;
export const getPeriodSelectorPredefinedRange = state => state.periodSelector.predefinedRange;

export const getPeriod = state => ({
  startDate: getPeriodSelectorStartDate(state),
  endDate: getPeriodSelectorEndDate(state),
  dateField: getPeriodSelectorDateField(state),
  datePicker: getPeriodSelectorDatePicker(state),
});
export const getDateField = state =>
  state.periodSelector.dateField;

export const getSelectedDatePicker = state => state.periodSelector.datePicker;

export const getWeekPickerDates = state => state.periodSelector.weekPicker;
export const getMonthPickerDates = state => state.periodSelector.monthPicker;
export const getDayPickerDates = state => state.periodSelector.dayPicker;

export const getApiPeriod = (selectionCriteria) => {
  const API_DATE_FORMAT = 'YYYY-MM-DD';

  if (!selectionCriteria.period.startDate && !selectionCriteria.period.endDate) {
    throw Error('No period selected');
  }

  const { startDate, endDate } = selectionCriteria.period;

  return {
    from: (startDate || endDate).format(API_DATE_FORMAT),
    to: (endDate || startDate).format(API_DATE_FORMAT),
  };
};

